import { useEffect } from 'react'
import { compose, branch, renderComponent } from 'recompose'

import { userSelector } from 'auth/selectors'

import LoginSignUpContainer from '@components/LoginSignUpContainer'
import ErrorMessage from 'shared/components/ErrorMessage'
import { CardSection } from '@components/CardSection'
import withRates from '@booking/components/withRates'
import { SHOW_PREPAID_FLOW } from '@booking/constants'

import { CARDS } from '../reducers'

import RateList from './RateList/RateList'

const PrepaidSelection = ({
    selectedRateId,
    ratesPending,
    makePurchasePending,
    disabledCards,
    filteredRates,
    areRatesPending,
    ratesError,
    onRateSelected,
    enableCard,
}) => {
    useEffect(() => {
        enableCard([CARDS.AVAILABLE_PRODUCTS, CARDS.SELECT_PARKING_TIME, CARDS.PAY_FOR_PARKING])
    }, [])

    const rates = filteredRates.filter(rate => {
        const defaultCustomerFlowArr = rate.defaultCustomerFlow.split('|')
        return !!defaultCustomerFlowArr.some(element => SHOW_PREPAID_FLOW.includes(element))
    })

    return (
        <>
            {(!disabledCards[CARDS.AVAILABLE_PRODUCTS] && ratesError) ||
            (!areRatesPending && filteredRates.length === 0) ? (
                <ErrorMessage messages={[ratesError ? ratesError : <T>booking.error.rates.not.found</T>]} />
            ) : (
                <CardSection
                    disabled={disabledCards[CARDS.AVAILABLE_PRODUCTS]}
                    loading={areRatesPending}
                    title={<T>booking.avail.products.label</T>}>
                    <RateList
                        discountedRateId={null}
                        promoCodeDiscount={0}
                        selectRate={onRateSelected}
                        rates={rates}
                        selectedRateId={selectedRateId}
                        disabled={(ratesPending && !(ratesPending instanceof Error)) || makePurchasePending === true}
                    />
                </CardSection>
            )}
        </>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            user: userSelector,
        })
    ),
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent(withRates(PrepaidSelection)))
)()
